export default "__VITE_ASSET__CuCMfsEX__"